import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=5ae65286"
import script from "./SalesHistory.vue?vue&type=script&lang=js"
export * from "./SalesHistory.vue?vue&type=script&lang=js"
import style0 from "./SalesHistory.vue?vue&type=style&index=0&id=5ae65286&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports